import { render, staticRenderFns } from "./YagiPostCard.vue?vue&type=template&id=3d83aa9a&scoped=true&"
import script from "./YagiPostCard.vue?vue&type=script&lang=js&"
export * from "./YagiPostCard.vue?vue&type=script&lang=js&"
import style0 from "./YagiPostCard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./YagiPostCard.vue?vue&type=style&index=1&id=3d83aa9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d83aa9a",
  null
  
)

export default component.exports